var Local = window.ScriptSocial = (function ( $ ) {

    var BASE_URL = "http://sigam-es.akamaized.net/demo/avatars/",
        PHOTO_MALE = $.map( new Array( 17 ), function ( item, i ) {
            return BASE_URL + "male_photo_" + i.toString() + ".jpg"
        } ),
        PHOTO_FEMALE = $.map( new Array( 17 ), function ( item, i ) {
            return BASE_URL + "female_photo_" + i.toString() + ".jpg"
        } ),
        SEX = [ Social.profile.GENDER_MALE, Social.profile.GENDER_FEMALE ];

    var NAME_MALE = [
        "Harlen Shklar",
        "Kristian Sharrer",
        "Artie Titilah",
        "Hurleigh Blackett",
        "Conrade Lineback",
        "Etan Galante",
        "Tiler Wacker",
        "Gabbie Sczech",
        "Stillmann Zacks",
        "Wald Bonventre",
        "Lonnard Stobaugh",
        "Derick Renaud",
        "Vassily Loader",
        "Osbourn Emmons",
        "Nels Veronese",
        "Harman Spingel",
        "Gale Kalb"
    ];

    var NAME_FEMALE = [
        "Mira Dabrowski",
        "Virgina Marruco",
        "Juanita Bisho",
        "Lanna Zalot",
        "Josey Bemmaor",
        "Lucienne Ciulla",
        "Adelaida Moshiri",
        "Kandace Quist",
        "Vivienne Gossard",
        "Lyn Frenk",
        "Abigail Lankes",
        "Arielle Hyman",
        "Adorne Marek-sadowska",
        "Arluene Rahilly",
        "Augustine Costas",
        "Cate Lefkovitch",
        "Shae Stuart"
    ];

    var iframeParams = Params.fromSearch();

    function generateProfiles( ids ) {
        if ( ids.length ) {
            if ( typeof ids === "string" ) {
                ids = ids.split( ',' );
            }
            return $.map( ids, function ( id ) {
                var str = id;
                var index = 0;
                for ( var i = 0, chr; i < str.length; i++ ) {
                    chr = str.charCodeAt( i );
                    index = index * 10 + chr;
                }
                var sex = SEX[ index % SEX.length ];
                var url = BASE_URL + "user/" + id;
                if ( sex === "male" ) {
                    return {
                        id : id,
                        gender : sex,
                        name : NAME_MALE[ index % NAME_MALE.length ],
                        photo : PHOTO_MALE[ index % PHOTO_MALE.length ],
                        url : url
                    }
                } else {
                    return {
                        id : id,
                        gender : sex,
                        name : NAME_FEMALE[ index % NAME_FEMALE.length ],
                        photo : PHOTO_FEMALE[ index % PHOTO_FEMALE.length ],
                        url : url
                    }
                }
            } );
        }
        return [];
    }

    var Local = function ( opt ) {

        this.ready = Signal.create( this, true );
        this.failed = Signal.create( this, true );
        this.isReady = true;
        var game = opt.game;

        Logger.log( "Local", opt );

        var social = this.social = new Social( opt.jsServerName, {
            getProfiles : function ( params, callback ) {
                Logger.log( "getProfiles", params, callback );
                setTimeout( function () {
                    callback.success(
                        generateProfiles( params.ids )
                    );
                }, 100 );
            },
            getProfile : function ( params, callback ) {
                Logger.log( "getProfile", params, callback );
                setTimeout( function () {
                    callback.success(
                        generateProfiles( params.id )[0]
                    );
                }, 100 );
            },
            getFriendsProfiles : function ( params, callback ) {
                Logger.log( "getFriendsProfiles", params, callback );
                var inGame = params.inGame;
                if ( inGame ) {
                    setTimeout( function () {
                        callback.success(
                            generateProfiles( iframeParams.friendsIds || '' )
                        );
                    }, 100 );
                } else {
                    setTimeout( function () {
                        callback.success(
                            generateProfiles( iframeParams.friendsNotInGameIds || '' )
                        );
                    }, 100 );
                }
            },
            share : function ( params, callback ) {
                callback.success();
            },
            getCurrentShares : function ( params, callback ) {
                callback.success( null );
            },
            buy : function ( params, callback ) {
                callback.success( { useServer : true } );
            },
            manageSubscription : function ( params, callback ) {
                callback.success( { useServer : true } );
            },
            reload : function ( params, callback ) {
                location.reload();
            },
            shutdown : function ( params, callback ) {
                var errId = params.errorId;
                var text = "";
                if (L10N.hasString(errId))
                    text = L10N.getString(errId);
                else
                    text = L10N.getString( "ERROR_APP" ) + " (" + errId + ")";

                game.shutdown(text);
                callback.success();
            },
            inviteFriends : function ( params, callback ) {

            },
            getReferrerInfo : function ( params, callback ) {
                var referrerInfo = {
                    'r' : 'local'
                };
                callback.success( referrerInfo );
            },
            getParsedRefererInfo : function ( params, callback ) {
                var result = {
                    promo_code: iframeParams['gift_key'],
                    webref: iframeParams['ref']
                };
                callback.success( result );
            },
            insertLikeButton : function ( params, callback ) {
                params = params || {};
                var target = params.target ? $( params.target ) :  $( 'body' );
                target.append( '<div style="display: block;width:120px;height:18px;line-height:18px;background:#f00;text-align:center;border:solid 1px #600;color:#600">Like</button>' );
                callback.success({});
            },
            isInCommunity : function ( params, callback ) {
                callback.success( { inCommunity : Math.random() < 0.1 } );
            },
            getPlatformFeatures: function (params, callback) {
                callback.success({
                    'friends': true,
                    'invitation': true,
                    'sharing': true
                })
            }
        } );

    };

    return Local;

})( jQuery );